import en_US from './en-US/';
import ja_JP from './ja-JP/';
import zh_TW from './zh-TW/';

export default { ...en_US, ...ja_JP, ...zh_TW };
